import type { StatusPresetMap } from './types'

export type FeatureSwitch = 'on' | 'off'

/**
 * An operator-facing feature switch. `off` is deliberately `neutral` rather than
 * `critical`: a feature someone turned off on purpose is a decision, not a
 * fault, and the incident it was pulled for is the thing that deserves alarm.
 */
export const featureSwitchPresets: StatusPresetMap<FeatureSwitch> = {
  on: { label: 'On', tone: 'success' },
  off: { label: 'Off', tone: 'neutral' },
}
